import { useForm } from 'react-hook-form';

import { DailySchedulesFormData } from '../types';

type UseDailySchedulesFormProps = {
  defaultValues?: Partial<DailySchedulesFormData>;
};

export function useDailySchedulesForm({ defaultValues }: UseDailySchedulesFormProps = {}) {
  return useForm<DailySchedulesFormData>({
    mode: 'all',
    defaultValues: {
      schedules: [],
      ...defaultValues,
    },
  });
}
